import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import 'v-calendar/style.css'
import 'vue3-toastify/dist/index.css'
import '@shared/utils/setupDatadog'

import router from '@router'
import { getPlatformFromUrl } from '@shared/composables/useWhitelabelService'
import { setupSentry } from '@shared/utils/setupSentry'
import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VCalendar from 'v-calendar'
import { createApp } from 'vue'
import Vue3Toasity, { type ToastContainerOptions } from 'vue3-toastify'

import App from '@/App.vue'

const platform = getPlatformFromUrl()

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
app.config.globalProperties.platform = platform
app.use(router)
app.use(pinia)
app.use(VCalendar, {})
app.use(Vue3Toasity, { clearOnUrlChange: false } as ToastContainerOptions)
app.use(createHead())
setupSentry(app)
app.mount('#app')
